import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08995ccb")

_pushScopeId("data-v-08995ccb")
const _hoisted_1 = { class: "text-gray-333 basic-flow-create-container" }
const _hoisted_2 = { class: "font-bold font-size-24 mb-8" }
const _hoisted_3 = { class: "flex mb-4" }
const _hoisted_4 = { class: "mr-4" }
const _hoisted_5 = { class: "font-size-14 font-bold" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "font-size-14 font-bold" }
const _hoisted_8 = { class: "font-size-14 font-bold" }
const _hoisted_9 = { class: "font-size-12" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex block"
}
const _hoisted_12 = { class: "flex mt-8" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-2xl" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_RadioInputGroup = _resolveComponent("RadioInputGroup")
  const _component_InputSearchEmployee = _resolveComponent("InputSearchEmployee")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.backBasicFlowSettingsList }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('basicFlow')) + "：" + _toDisplayString(_ctx.applicationDefineName), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('copyTheApplicationFlow')), 1),
        _createVNode(_component_Dropdown, {
          "sub-label": _ctx.t('youCanCopyTheApplicationFlowOfOtherApplications'),
          class: "w-112 mt-1",
          placeholder: _ctx.t('placeholderSelect'),
          modelValue: _ctx.formDataBasicFlow.application_define,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formDataBasicFlow.application_define = $event)),
          "item-text": "application_define_name",
          "item-value": "application_define_id",
          "options-select": _ctx.applicationBasicFlowSettingsList,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeAppFormDefines($event))),
          isFixed: ""
        }, null, 8, ["sub-label", "placeholder", "modelValue", "options-select"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('numberOfApprovedFlows')), 1),
      _createVNode(_component_Dropdown, {
        class: "w-20",
        "options-select": _ctx.numberOfApprovedFlowsList,
        modelValue: _ctx.formDataBasicFlow.total_level,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formDataBasicFlow.total_level = $event)),
        onChange: _ctx.changeTotalLevel
      }, null, 8, ["options-select", "modelValue", "onChange"])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formDataBasicFlow.total_level, (applicationFlowDetail, approvalLevelIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "mb-4",
        key: JSON.stringify(applicationFlowDetail)
      }, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t(`fullWidth${approvalLevelIndex + 1}`)) + _toDisplayString(_ctx.t('primaryApprovalFlow')), 1),
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Table, {
                key: 0,
                class: "mt-1",
                data: 
            _ctx.applicationFlowDetailsByLevel(approvalLevelIndex + 1).concat({})
          ,
                headers: _ctx.headersBasicFlow
              }, {
                "header-authorizer": _withId(({ item }) => [
                  _createVNode("div", _hoisted_9, _toDisplayString(item.text), 1)
                ]),
                action: _withId(({ index, item }) => [
                  _createVNode("div", _hoisted_10, [
                    (
                  _ctx.applicationFlowDetailsByLevel(approvalLevelIndex + 1)
                    .length === index
                )
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: "cp-icon-plus cursor-pointer font-size-32 text-light-blue border-1 border-color-grey-dc rounded-50 hover:opacity-75",
                          onClick: ($event: any) => (_ctx.addApplicationFlow(index, approvalLevelIndex))
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock("span", {
                          key: 1,
                          class: ["cursor-pointer cp-icon-minus font-size-32 text-red-ff border-1 border-color-grey-dc rounded-50 hover:opacity-75", 
                  _ctx.applicationFlowDetailsByLevel(approvalLevelIndex + 1).length >
                  1
                    ? 'cursor-pointer'
                    : 'pointer-events-none'
                ],
                          onClick: ($event: any) => (_ctx.removeApplicationFlow(item, approvalLevelIndex))
                        }, null, 10, ["onClick"]))
                  ])
                ]),
                authorizer: _withId(({ index, item }) => [
                  (
                _ctx.applicationFlowDetailsByLevel(approvalLevelIndex + 1).length >
                index
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode(_component_RadioInputGroup, {
                          class: "mt-4 -mr-3 min-w-40",
                          "options-radio": _ctx.roleOptionList,
                          modelValue: item.setting_register_flow,
                          "onUpdate:modelValue": ($event: any) => (item.setting_register_flow = $event)
                        }, null, 8, ["options-radio", "modelValue", "onUpdate:modelValue"]),
                        (
                  item.setting_register_flow ===
                  _ctx.SETTING_REGISTER_FLOW.PERSON_DESIGNATION
                )
                          ? (_openBlock(), _createBlock(_component_InputSearchEmployee, {
                              key: 0,
                              class: "flex-1",
                              modelValue: item.pp_employee_ids,
                              "onUpdate:modelValue": ($event: any) => (item.pp_employee_ids = $event),
                              options: _ctx.employeeList,
                              "item-value": "id",
                              "item-text": "name",
                              "item-url": "photo",
                              required: "",
                              validated: _ctx.validated,
                              errors: 
                  _ctx.errors[
                    `application_flow_details.${item.approval_level}.${item.level_order}.pp_employee_ids`
                  ]
                ,
                              "onUpdate:errors": ($event: any) => (
                  _ctx.errors[
                    `application_flow_details.${item.approval_level}.${item.level_order}.pp_employee_ids`
                  ]
                 = $event),
                              placeholder: _ctx.t('pleaseEnterYourName')
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "validated", "errors", "onUpdate:errors", "placeholder"]))
                          : (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 1,
                              class: "flex-1",
                              modelValue: item.role_ids,
                              "onUpdate:modelValue": ($event: any) => (item.role_ids = $event),
                              options: _ctx.roleData,
                              "item-text": "role_name",
                              "item-value": "id",
                              required: "",
                              validated: _ctx.validated,
                              errors: 
                  _ctx.errors[
                    `application_flow_details.${item.approval_level}.${item.level_order}.role_ids`
                  ]
                ,
                              "onUpdate:errors": ($event: any) => (
                  _ctx.errors[
                    `application_flow_details.${item.approval_level}.${item.level_order}.role_ids`
                  ]
                 = $event),
                              placeholder: _ctx.t('placeholderSelect')
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "validated", "errors", "onUpdate:errors", "placeholder"]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["data", "headers"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        class: "mr-4",
        onClick: _ctx.onSubmitCreateBasicFlow,
        disabled: _ctx.isDisableSubmit
      }, {
        default: _withId(() => [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.t('save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_Button, {
        variant: "outline-primary",
        onClick: _ctx.backBasicFlowSettingsList
      }, {
        default: _withId(() => [
          _hoisted_14,
          _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})